import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import { Input, Button, message, Tabs, Table, Statistic, Carousel } from 'antd';
import { CheckOutlined, FileTextOutlined, ShoppingCartOutlined, CalendarOutlined } from '@ant-design/icons';
import { addProduct } from '../../store/actions/shopCartActions';
import { planListAddProduct } from '../../store/actions/planListActions';
import { renderStatusTagInfo, preSaleTip, preSaleStatusActionText, preCountDownText } from '../../util/preSale';
import { getProductList, orderPlanTaskReserve } from '../../util/api';
import { amountToString } from '../../util/tool';
import CpLoading from '../../components/CpLoading';
import moment from 'moment';
import { queryString } from '../../util/qs';
import { accAdd, accSub } from '../../util/math';
import './style.less';

const { Countdown } = Statistic;
const columns = [
	{
		title: '种植养殖操作',
		dataIndex: 'operation',
	},
	{
		title: '开始日期',
		dataIndex: 'start_date',
	},
	{
		title: '结束日期',
		dataIndex: 'end_date',
	},
	{
		title: '操作描述',
		dataIndex: 'operation_desc',
	},
];
const { scrollTo } = window;
class ProductDetail extends Component {
	constructor(props) {
		super(props);
		const { spuId, orgId, normsId } = this.props.match.params;
		this.skuId = spuId;
		this.orgId = orgId;
		this.normsId = normsId;
		this.carouselRef = createRef();
		this.videoRef = createRef();
	}
	state = {
		previewFile: {},
		previewIndex: 0,
		attrIndex: 0,
		spuInfo: {},
		skuList: [],
		supplierName: '',
		num: 1,
		normsId: 0,
		saleId: 0,
		fileList: [],
		detailList: [],
		loading: true,
		storkSale: {
			price: '',
			stock_cur_num: '',
			unit: '',
			tax_sale_price: ''
		},
		contact: '',
		contact_detail: '',
		sale_desc: '',
		place: '',
		tax_rate: 0,
		slideNum: 0,
		isPlaying: false,
		videoSrc: '',
		current: 0,
	}
	async productInit() {
		const { data: { data, code, msg } } = await getProductList({
			spu_id: this.skuId,
			org_id: this.orgId
		});
		if (code === 0) {
			const {
				sku_list: skuList,
				spu_info: spuInfo,
			} = data;
			if (skuList.length) {
				// 根据传入的saleId获取对应的数据
				let index = skuList.findIndex(obj => String(obj.norms_id) === String(this.normsId));
				index = index === -1 ? 0 : index;
				let obj = skuList[index] || {};
				const {
					norms_id: normsId,
					sale_id: saleId,
					supplier_name: supplierName,
					sale_price: salePrice,
					stock_cur_num: stockCurNum,
					unit,
					sale_max_count_day,
					sale_min_count,
					sale_name,
					is_base_purchase = 0,
					is_pre_sale = false,
					pre_sale = {},
					sku_sn,
					contact,
					contact_detail,
					is_plan_list,
					is_shop_cart,
					sale_desc,
					place,
					tax_rate,
					tax_sale_price
				} = obj;
				this.setState({
					attrIndex: index,
					spuInfo: spuInfo || {},
					skuList: skuList || [],
					supplierName: supplierName || '',
					saleName: sale_name || '',
					is_base_purchase,
					is_pre_sale,
					pre_sale,
					skuSn: sku_sn || '',
					saleId: saleId || '',
					normsId: normsId || '',
					storkSale: {
						price: salePrice || '',
						stock_cur_num: stockCurNum.cur_num || stockCurNum,
						unit: unit || '',
						tax_sale_price
					},
					contact,
					contact_detail,
					saleMaxCountDay: sale_max_count_day,
					saleMinCount: sale_min_count,
					loading: false,
					is_plan_list,
					is_shop_cart,
					sale_desc,
					place,
					tax_rate
				}, () => {
					this.getProductSale(saleId);
				});
			} else {
				message.info('该商品不存在!');
				const timer = setTimeout(() => {
					this.props.history.go(-1);
					clearTimeout(timer);
				}, 1000);
				return;
			}

		} else {
			message.error(msg);
		}
	}
	async componentDidMount() {
		scrollTo(0, 0);
		this.productInit();
	}
	page = 0
	handleNext = (e) => {
		e.stopPropagation();
		this.carouselRef.next();
		this.setState((pre) => ({ slideNum: pre.slideNum + 1 }));
	}
	handlePrev = (e) => {
		e.stopPropagation();
		this.carouselRef.prev();
		this.setState((pre) => ({ slideNum: pre.slideNum - 1 }));
	}
	onFileClick(item, index) {
		this.setState({ previewFile: item, previewIndex: index }, () => {
			if (item.file_type === 1) {
				this.setState({ videoSrc: item.file_url }, () => {
					this.videoRef.play();
				});
			} else {
				this.state.videoSrc && this.videoRef.pause();
			}
		});
	}
	videoPause = () => {
		this.setState(() => ({ isPlaying: false }));
	}
	videoPlay = () => {
		this.setState(() => ({ isPlaying: true }));
	}
	startPlaying = () => {
		this.setState({ isPlaying: false }, () => {
			this.state.videoSrc && this.videoRef.play();
		});
	}
	handleSale = (id, index) => {
		const { skuList } = this.state;
		let list = skuList && skuList.length && skuList.filter(item => item.norms_id === id);
		const [{
			sale_price: salePrice,
			stock_cur_num: stockCurNum,
			unit,
			sale_id: saleId,
			norms_id: normsId,
			supplier_name: supplierName,
			sale_max_count_day,
			sale_min_count,
			sale_name,
			is_base_purchase = 0,
			is_pre_sale = false,
			pre_sale = {},
			sku_sn,
			contact,
			contact_detail,
			is_plan_list,
			is_shop_cart,
			sale_desc,
			place,
			tax_rate,
			tax_sale_price
		}] = list;
		this.setState({
			attrIndex: index,
			previewIndex: 0,
			saleName: sale_name || '',
			is_base_purchase,
			is_pre_sale,
			pre_sale,
			skuSn: sku_sn || '',
			saleId,
			normsId,
			supplierName,
			storkSale: {
				price: salePrice || '',
				stock_cur_num: stockCurNum.cur_num || stockCurNum,
				unit: unit || '',
				tax_sale_price
			},
			contact,
			contact_detail,
			saleMaxCountDay: sale_max_count_day,
			saleMinCount: sale_min_count,
			is_plan_list,
			is_shop_cart,
			sale_desc,
			place,
			tax_rate,
		});
		this.getProductSale(id);
	}
	getProductSale = (normsId) => {
		const { skuList } = this.state;

		let index = skuList.findIndex(obj => String(obj.norms_id) === String(normsId));
		index = index === -1 ? 0 : index;
		let obj = skuList[index] || {};
		const { sys_album: { detail, rotation } } = obj;
		const previewFile = rotation?.[0] || {};
		this.setState({
			detailList: detail || [],
			fileList: rotation || [],
			previewFile,
			slideNum: rotation?.length > 4 ? 4 : 0,
			videoSrc: `${previewFile.file_type}` === '0' ? '' : previewFile.file_url,
		});
	}
	add = (product) => {
		let num = Number(product) + 1;
		this.setState({
			num
		});
	}
	reduce = (product) => {
		let value = Number(product);
		if (value - 1 < 1) {
			message.info('不能再减少了哦');
			this.setState({
				num: 1
			});
		} else {
			this.setState({
				num: value - 1
			});
		}
	}
	inputChanged = (e, product) => {
		const value = e.target.value;
		this.setState({
			num: value
		});
	}
	onBlur = (e) => {
		const value = e.target.value;
		const regularValue = value.replace(/[^\d.]/ig, '');
		let lastValue = +parseFloat(regularValue).toFixed(3);
		if (isNaN(lastValue)) {
			message.info('请输入有效数字');
			this.setState({
				num: 1
			});
			return;
		}
		if (!lastValue) {
			message.info('商品数量必须大于0');
			this.setState({
				num: 1
			});
			return;
		}
		this.setState({
			num: lastValue
		});
	}
	addShopCart = () => {
		const { saleId, normsId, supplierName, saleMaxCountDay, saleMinCount, storkSale: { stock_cur_num, unit } } = this.state;
		const { addProduct, productsInCart } = this.props;
		let { num } = this.state;

		const cartProductInfo = productsInCart[normsId];
		let purchasedNum = 0;
		let total = num;
		if (cartProductInfo) {
			purchasedNum = cartProductInfo.num || 0;
			total = accAdd(purchasedNum, num);
		}

		let max = +(saleMaxCountDay) === 0 ? +(stock_cur_num) : (+(stock_cur_num) < +(saleMaxCountDay)) ? +(stock_cur_num) : +(saleMaxCountDay);
		if (total > max) {
			num = accSub(max, purchasedNum);
		}
		if (total < +(saleMinCount)) {
			message.info('商品数量不能小于最小起订量');
			return;
		}

		if (num < 0) {
			message.info('超过最大可购买量，不能再加了');
			return;
		}

		// let wrap = document.querySelector('.tabs-tip');
		// wrap.style.opacity = 1;
		// let span = document.querySelector('.tabs-tip > span');
		// span.innerHTML = '成功加入购物车!';

		const product = {
			id: saleId,
			normsId: normsId,
			supplier_id: this.orgId,
			supplier_name: supplierName,
			sellerId: this.orgId,
			sellerName: supplierName,
			unit: unit
		};

		this.setState({
			num
		});
		addProduct(product, num);
		message.success('成功加入购物车!');
		// const timer = setTimeout(() => {
		// 	wrap.style.opacity = 0;
		// 	clearTimeout(timer);
		// }, 1000);
	}
	addPlanList = () => {
		const { saleId, normsId, supplierName, storkSale: { unit } } = this.state;
		const { planListAddProduct } = this.props;
		let { num } = this.state;
		// let wrap = document.querySelector('.tabs-tip');
		// wrap.style.opacity = 1;
		// let span = document.querySelector('.tabs-tip > span');
		// span.innerHTML = '成功加入计划清单!';

		let product = {
			id: saleId,
			normsId: normsId,
			supplier_id: this.orgId,
			supplier_name: supplierName,
			sellerId: this.orgId,
			sellerName: supplierName,
			unit: unit
		};

		this.setState({
			num
		});
		planListAddProduct(product, num);
		message.success('成功加入计划清单!');
		// const timer = setTimeout(() => {
		// 	wrap.style.opacity = 0;
		// 	clearTimeout(timer);
		// }, 1000);
	}

	preAdd = async ({ is_pre_sale, pre_sale = {}, tagStatusInfo }) => {
		const { pre_sale_goods_id } = pre_sale;
		const { num } = this.state;
		const { data: { code, msg } } = await orderPlanTaskReserve({ pre_sale_goods_id, number: num });
		if (+code === 0) {
			message.success('预定成功', .5, () => {
				scrollTo(0, 0);
				this.productInit();
			});
		} else {
			message.error(msg);
		}
	}
	componentWillUnmount() {
		this.setState = () => false;
	}
	render() {
		const currencyStringify = JSON.parse(localStorage.getItem('currencyItem') || { "id": 3, "currency": "人民币", "currency_symbol": "¥", "currency_en": "RMB", "exchange_rate": "1.0000", "status": 1 });
		const { currency_en, exchange_rate, currency_symbol } = currencyStringify;
		const { fileList = [], detailList, skuList, previewFile, supplierName, num, saleMinCount, loading, saleName, skuSn, storkSale, is_base_purchase = 0, pre_sale = {}, is_pre_sale = false, spuInfo, contact, contact_detail, is_plan_list, is_shop_cart, sale_desc, place, tax_rate, previewIndex, videoSrc, current } = this.state;
		const { status: pre_status = 0, is_reserve = false, pre_sale_goods_id = '', order_no = '' } = pre_sale;
		const tagStatusInfo = is_pre_sale && renderStatusTagInfo(pre_sale);
		const { computedStatus, countDownTime, showTipTime } = tagStatusInfo;
		const messageModal = (
			<div
				className="tabs-tip"
				style={{
					transition: 'opacity 0.5s ease',
					opacity: 0,
					background: '#D60505',
					position: 'fixed',
					left: '45%',
					top: '10%',
					zIndex: 1000,
					padding: '0 10px',
					lineHeight: '35px',
					borderRadius: 5,
					color: '#fff',
				}}
			>
				<i style={{ width: 15, height: 12 }}><CheckOutlined /></i>
				<span>成功加入购物车!</span>
			</div>
		);
		const baseItems = [
			{
				label: '商品详情', key: '1', children: <>
					<div className='product-location-info'>
						<span>商品条码(UPC码)：{spuInfo?.barcode}</span>
						<span>商品名称：{spuInfo?.spu_name}</span>
						<span>保质期：{spuInfo?.shelf_life}</span>
						<span>储藏方式：{spuInfo?.storage?.name}</span>
						<span>品牌：{spuInfo?.brand_name}</span>
						<span>产地：{place || spuInfo?.place}</span>
					</div>
					{sale_desc ? <div dangerouslySetInnerHTML={{ __html: sale_desc }}></div> : (detailList || [])?.map?.((item, index) => <img src={item.file_url} key={index} alt="图片"></img>)}
				</>
			},
			{
				label: '基地信息', key: '2', children: <>
					<div className='product-location-title'>种植/养殖信息</div>
					<div className='product-location-info'>
						<span>基地名称：{pre_sale?.base_company_name || '-'}</span>
						<span>种植方式：{pre_sale?.plant?.planting_method || '-'}</span>
						<span>产区面积：{`${pre_sale?.plant?.area || ''}${pre_sale?.plant?.area_unit || '-'}`}</span>
						<span>预估产量：{`${pre_sale?.plant?.estimate_output || ''}${pre_sale?.plant?.base_unit || '-'}`}</span>
						<span>预计上市日期：{pre_sale?.plant?.time_to_market || '-'}</span>
					</div>
					<Table columns={columns} rowKey='id' dataSource={pre_sale?.plant?.info || []} pagination={false} />
				</>
			},
		];

		const items = is_pre_sale ? baseItems : baseItems.slice(0, 1);
		return (
			<div className="product">
				{loading ? <CpLoading size="large" className="cp-loading" /> : null}
				<div className="product-intro">
					<div className="preview-wrap">
						<div className="preview-wrap-gallery">
							{Reflect.ownKeys(previewFile).length ? <>
								<img src={previewFile.file_url} alt='' style={{ display: `${previewFile.file_type}` === '0' ? '' : 'none' }} />
								<div className={['video-container', this.state.isPlaying ? '' : 'paused'].join(' ')}>
									{videoSrc && <video onPlay={this.videoPlay} onPause={this.videoPause} autoPlay ref={el => this.videoRef = el} controls muted controlsList="nodownload nofullscreen noplaybackrate" disablePictureInPicture><source src={previewFile.file_url} type="video/mp4" /></video>}
									{!this.state.isPlaying ? <div className='play-icon' onClick={this.startPlaying}></div> : null}
								</div>
							</> : null}
						</div>
						<div className="preview-wrap-list">
							{
								fileList?.length > 4 ? <>
									{current ? <div onClick={this.handlePrev} className="preview-wrap-prev preview-btn"></div> : null}
									{fileList.length > 4 + current ? <div onClick={this.handleNext} className="preview-wrap-next preview-btn"></div> : null}
								</> : null
							}
							<Carousel dots={false} slidesToShow={4} slidesToScroll={1} ref={el => this.carouselRef = el} infinite={false} afterChange={(current) => { this.setState({ current }); }}>
								{fileList.map((item, index) => (
									<div key={index} >
										<div onClick={() => this.onFileClick(item, index)} className={['preview-wrap-item', previewIndex === index ? 'active' : '', `${item.file_type}` === '0' ? '' : 'file-video'].join(' ')} >
											{`${item.file_type}` === '0' ? <img src={item.file_url} alt="" /> : <video controls={false}><source src={item.file_url} type="video/mp4" /></video>}
										</div>
									</div>))}
							</Carousel>
						</div>
					</div>
					<div className="itemInfo-wrap">
						<div className='product-title'>
							<div className='product-title-content'>
								{is_base_purchase ? <div className='product-title-location'>基地</div> : null}
								<div className="sku-name"> {saleName}</div>
							</div>
							<div className='product-count-down'>
								{is_pre_sale ? <span className='product-count-down-time'>{preSaleTip[computedStatus]}时间:{moment(showTipTime).format('YYYY-MM-DD')}</span> : null}
								{/* {is_pre_sale && countDownTime && <Countdown prefix={`${preSaleStatusText[pre_status]}剩余时间:`} value={countDownTime} format="D天H时m分s秒" onFinish={() => this.productInit()} />} */}
								{is_pre_sale && countDownTime && <Countdown prefix={`${preCountDownText[computedStatus]}:`} value={countDownTime} format="D天H时m分s秒" onFinish={() => this.productInit()} />}
								{is_reserve ? <span className='product-count-down-status'>已预订</span> : null}
							</div>
						</div>
						<div className="price-panel">
							<div className="price-panel-summary">
								<span className="price-panel-title">编号</span>
								<span>{skuSn}</span>
							</div>
							<div className="price-panel-sales">
								<span className="price-panel-title">销售价</span>
								<span style={{ color: '#D60505' }}>{currency_en === "RMB" ? <span className="sales-price"><i>{currency_symbol}</i>{amountToString(storkSale.price)}</span> : <span className="sales-price"><i>{currency_symbol}</i>{amountToString(storkSale.price / exchange_rate, 4)}</span>}（未税价）</span>
								{
									+tax_rate > 0 ? (
										<><span className="sales-price-line"></span>
											<span style={{ color: '#D60505' }}>{currency_en === "RMB" ? <span className="sales-price"><i>{currency_symbol}</i>{amountToString(storkSale.tax_sale_price)}</span> : <span className="sales-price"><i>{currency_symbol}</i>{amountToString(storkSale.tax_sale_price / exchange_rate, 4)}</span>}（预估含税价）</span></>
									) : null
								}

							</div>
							<div className="price-panel-stock">
								<span className="price-panel-title"></span>
								<span>增值税率：{+tax_rate}%</span>
							</div>
							<div className="price-panel-stock">
								<span className="price-panel-title">库存</span>
								<span>{`${+storkSale.stock_cur_num} ${storkSale.unit}`}</span>
							</div>
							<div className="price-panel-supplier">
								<span className="price-panel-title">供应商</span>
								<span>{supplierName}</span>
								<span className='contact-span'>联系人：{contact || '-'}</span>
								<span className='contact-span'>联系方式：{contact_detail || '-'}</span>
							</div>
							<div className="price-panel-height"></div>
						</div>
						<div className="choose-attr">
							<div className="choose-attr-clothes">
								<span className="price-panel-title fixed">商品规格</span>
								<div className="choose-attr-items-container">
									{
										skuList && skuList.length > 0 && skuList.map((item, index) => {
											return <span
												style={{
													border: index === this.state.attrIndex ? '1px solid #D60505' : '',
													cursor: 'pointer'
												}}
												key={index}
												value={item.norms_id}
												onClick={() => this.handleSale(item.norms_id, index)}
												className="choose-attr-items" >{item.unit_desc}</span>;
										})
									}
								</div>
							</div>
							<div className="choose-attr-num">
								<span className="price-panel-title">商品数量</span>
								<div className="choose-attr-amount">
									<a className="choose-attr-icon" onClick={() => { this.reduce(num); }}>-</a>
									<Input
										className="choose-attr-input"
										defaultValue={1}
										value={num}
										onChange={(e) => { this.inputChanged(e); }}
										onBlur={(e) => { this.onBlur(e); }}
										onPressEnter={(e) => { this.onBlur(e); }}
									/>
									<a className="choose-attr-icon" onClick={() => { this.add(num); }}>+</a>
								</div>
								<div className="mini-sale-count" hidden={saleMinCount <= 1}>起订量：{saleMinCount}</div>
							</div>
							{is_reserve ? <div className="price-panel-summary" style={{ marginTop: '30px' }}><span className="price-panel-title">提报数量：</span><span>{pre_sale?.submit}</span>	</div> : null}
							<div className="choose-attr-btn">
								{!is_pre_sale ?
									(is_plan_list ? <Button className="choose-attr-btn-value plan" onClick={this.addPlanList} icon={<FileTextOutlined />}>加入计划清单</Button> : null)
									: null}
								{
									!is_pre_sale ? //  is_pre_sale 是否预售商品
										(is_shop_cart ? <Button
											className='choose-attr-btn-value'
											onClick={(e) => {
												e.stopPropagation();
												this.addShopCart();
											}}>
											<ShoppingCartOutlined /><span className='product-info-title'>加入购物车</span>
										</Button> : null)
										: <>
											{/* 预售待开始：预订 置灰 */}
											{
												computedStatus === 0 ? <Button
													className="choose-attr-btn-value"
													disabled
													icon={<CalendarOutlined />}
												>{preSaleStatusActionText[pre_status]}</Button> : null
											}
											{/* 预售：预订 */}
											{
												(computedStatus === 1 ? <Button
													className="choose-attr-btn-value"
													icon={<CalendarOutlined />}
													onClick={(e) => {
														e.stopPropagation();
														this.preAdd({ is_pre_sale, pre_sale, tagStatusInfo });
													}}
												>{preSaleStatusActionText[pre_status]}</Button> : null)
											}
											{/* 采购待开始：（未预订）-》加入购物车置灰 （已预订）-》转订单置灰 */}
											{
												(computedStatus === 2 || computedStatus === 3) ? (!is_reserve ?
													// （未预订）-》加入购物车置灰
													<Button
														className="choose-attr-btn-value"
														disabled={computedStatus === 2}
														icon={<ShoppingCartOutlined />}
														onClick={(e) => {
															e.stopPropagation();
															this.addShopCart();
														}}
													>{preSaleStatusActionText[pre_status + is_reserve]}</Button>
													:
													// （已预订）-》转订单置灰
													<Button
														className="choose-attr-btn-value plan"
														icon={<CalendarOutlined />}
														disabled={computedStatus === 2}
														onClick={(e) => {
															e.stopPropagation();
															this.props.history.push(`/basic/transfer/order?${queryString({ id: pre_sale_goods_id, orderId: order_no })}`);
														}}
													>{preSaleStatusActionText[pre_status + is_reserve]}</Button>) : ''
											}
										</>
								}

								{messageModal}
							</div>
						</div>
					</div>
				</div >
				<div className="product-detail">
					<Tabs defaultActiveKey="2" items={items}>
					</Tabs>
				</div>
			</div >
		);
	}
}

const mapStateToProps = (state) => {
	const { shopCart, planList } = state;
	const { products } = shopCart;
	const { products: planListProducts } = planList;
	return {
		productsInCart: products,
		productsInPlanList: planListProducts
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		addProduct: (product, count) => {
			dispatch(addProduct(product, count));
		},
		planListAddProduct: (product, count) => {
			dispatch(planListAddProduct(product, count));
		}
	};
};
export default connect(mapStateToProps, mapDispatchToProps)(ProductDetail);